export const ROOT_ROUTES = [
  'Login',
  'Onboardings',
  'Forms',
  'Checks',
  'End',
] as const;
